import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { OfflineDcrVerifyPage } from '@/features/billing/pages/OfflineDcrVerifyPage';
import { offlineDcrSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/offline-dcr-verify')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.OFFLINE_DCR_VERIFY_VIEW),
  validateSearch: offlineDcrSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Offline DCR Verify">
      <Suspense fallback={<PageLoader />}>
        <OfflineDcrVerifyPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
